import { S, ui, save } from "../../app/store.js";
import { can } from "../../services/access.js";
import { esc } from "../../domain/format.js";
import { log } from "../../services/audit.js";
import { render } from "../../app/shell.js";
import { finishCreation } from "../../components/creation-flow.js";
export function createSiteForm() {
  if (!can("gl.create")) return "";
  return `<details class="panel"><summary>Add site / location</summary><form id="create-site" class="work-log-form"><div class="form"><label>Location code<input name="code" placeholder="ABC-001" pattern="[A-Za-z]{3}-[0-9]{3}" required></label><label>Location name<input name="name" required></label><label>Wage region<select name="region"><option value="VI">Western Visayas · Region VI</option><option value="VII-A">Central Visayas · Class A</option></select></label></div>${ui.siteError ? `<p class="err">${esc(ui.siteError)}</p>` : ""}<button class="pri" type="submit">Create location</button></form></details>`;
}
export function installSiteEvents() {
  document.addEventListener("submit", (event) => {
    if (event.target.id !== "create-site") return;
    event.preventDefault();
    if (!can("gl.create")) return;
    const values = Object.fromEntries(new FormData(event.target)),
      code = values.code.trim().toUpperCase(),
      name = values.name.trim();
    if (
      !/^[A-Z]{3}-\d{3}$/.test(code) ||
      !name ||
      S.sites.some((s) => s.code === code)
    ) {
      ui.siteError = "Use a unique ABC-001 code and enter the location name.";
      return render();
    }
    const site = {
      id: "site-" + crypto.randomUUID(),
      code,
      name,
      region: values.region,
    };
    S.sites.push(site);
    ui.site = site.id;
    ui.siteError = "";
    log("Created location", code + " " + name);
    save();
    finishCreation();
    render();
  });
}
